import { apiClient } from '../utils/api-client'
import type { TrainingSession } from '../types/training-session'

interface TrainingSessionPayload {
  session_date: string
  session_type: string
  effort: number | null
  duration_minutes?: number | null
  note?: string | null
}

interface TrainingSessionResponse {
  data: {
    id: string
    type: string
    attributes: TrainingSession
  }
}

interface TrainingSessionsResponse {
  data: Array<{
    id: string
    type: string
    attributes: TrainingSession
  }>
}

class TrainingSessionsService {
  async list(from?: string, to?: string): Promise<TrainingSession[]> {
    const params = new URLSearchParams()
    if (from) params.set('from', from)
    if (to) params.set('to', to)
    const query = params.toString() ? `?${params}` : ''
    const response = await apiClient.get(`/api/training_sessions${query}`, { requireAuth: true })
    const json: TrainingSessionsResponse = await response.json()
    return json.data.map((d) => ({ ...d.attributes, id: d.id }))
  }

  async create(payload: TrainingSessionPayload): Promise<TrainingSession> {
    const response = await apiClient.post('/api/training_sessions', {
      data: { attributes: payload },
    }, { requireAuth: true })
    const json: TrainingSessionResponse = await response.json()
    return { ...json.data.attributes, id: json.data.id }
  }

  async update(id: string, payload: Partial<TrainingSessionPayload>): Promise<TrainingSession> {
    const response = await apiClient.patch(`/api/training_sessions/${id}`, {
      data: { attributes: payload },
    }, { requireAuth: true })
    const json: TrainingSessionResponse = await response.json()
    return { ...json.data.attributes, id: json.data.id }
  }

  async destroy(id: string): Promise<void> {
    await apiClient.delete(`/api/training_sessions/${id}`, { requireAuth: true })
  }
}

export const trainingSessionsService = new TrainingSessionsService()
